<template lang='pug'>
  el-dialog(title="添加参训人员"  :visible.sync="addVisible" width="60%" :append-to-body='true' :modal-append-to-body='false' @close="dailogclose")
    el-card(shadow="never")
      div(slot="header")
        font.font_label 请选择参训人员
      el-row
        el-col(:span='22')
          el-input(v-model='memberName' clearable='', style='width:80%;' placeholder="请输入姓名/级别/手机号码")
        el-col(:span='2')
          el-button(@click="getMemberList" style='float:right;' icon='el-icon-search') 查询
      el-row()
        el-table(:data="memberData" @row-click="checkMember" border v-loading="tabloading" @current-change="checkMember" ref="memTab" max-height="300" style='margin-top:20px' highlight-current-row)
            el-table-column(header-align='center' label='序号' align='center'  width='80')
                  template(scope="scope")
                      el-radio(class="radio" v-model="radio" :label="scope.$index +1")
            //- el-table-column(type="index" label="序号" align='center')
            el-table-column(prop="name" label="姓名" align='center' width='180')
              template(slot-scope="scope")
                  font(v-if="scope.row.name") {{scope.row.name}}
                  font(v-if="!scope.row.name") {{scope.row.nickname}}
            el-table-column(prop="mobile" label="会员账号" align='center')
            el-table-column(prop="level" label="会员等级" align='center')
            el-table-column(prop="gender" label="性别" align='center')
              template(slot-scope="scope")
                font(v-if="scope.row.gender === 0") 男
                font(v-if="scope.row.gender === 1") 女
        el-pagination(@size-change='sizeChangeHandle', @current-change='currentChangeHandle', :current-page='pageIndex', :page-sizes='[10, 20, 50, 100]', :page-size='pageSize', :total='totalPage', layout='total, sizes, prev, pager, next, jumper')
    el-card(shadow="never")
      div(slot="header")
        font.font_label 请填写青少年信息
      el-row
        el-form(:model="childrenInfo", :rules="InfoRules" :inline="false" ref="childrenInfos" label-width="80px")
          el-row
            el-col(:span="6")
              el-form-item(label="姓名：" prop="name")
                el-input(v-model='childrenInfo.name',clearable)
              el-form-item(label="身高：" prop="height")
                el-input(v-model.number='childrenInfo.height',clearable)
                  template(slot="suffix") cm
            el-col(:span="6")
              el-form-item(label="性别：" prop="sex")
                el-select(v-model="childrenInfo.sex" placeholder="请选择性别")
                  el-option(v-for="item in genderOptions" :key="item.value" :label="item.label" :value="item.value")
              el-form-item(label="关系：" prop="relation")
                el-select(v-model="childrenInfo.relation" placeholder="请选择关系")
                  el-option(v-for="item in relationOptions" :key="item.value" :label="item.label" :value="item.value")
            el-col(:span="6")
              el-form-item(label="年龄：" prop="age")
                el-select(v-model="childrenInfo.age" placeholder="请选择年龄")
                  el-option(v-for="item in ageOptions" :key="item" :label="item" :value="item")
                    span(style="float: left") {{ item }}
                    span(style="float: left; color: #8492a6; font-size: 13px") 岁
            el-col(:span="6")
              el-form-item(label="级别：" prop="level")
                el-select(v-model="childrenInfo.level" placeholder="请选择级别")
                  el-option(v-for="item in levelOptions" :key="item.value" :label="item.label" :value="item.value")
                el-input(v-model='childrenInfo.chid' v-show="false")
      el-row
        el-button(@click="delChildren" style='float:right;margin-left:10px' type="danger") 删除
        el-button(@click="addChildren" style='float:right;' type="primary") 添加
      el-row
        el-table(:data="childrenData" border @selection-change="childrenChecked" max-height="300" style='margin-top:20px')
          el-table-column(type="selection" align='center')
          el-table-column(prop="name" label="姓名" align='center')
          el-table-column(prop="sex" label="性别" align='center' )
              template(slot-scope="scope")
                  font(v-if="scope.row.sex === 0") 男
                  font(v-if="scope.row.sex === 1") 女
          el-table-column(prop="age" label="年龄" align='center')
          el-table-column(prop="level" label="级别" align='center' )
          el-table-column(prop="height" label="身高" align='center' )
          el-table-column(prop="relation" label="关系" align='center' )
              template(slot-scope="scope")
                  font(v-if="scope.row.relation === '1'") 家长
                  font(v-if="scope.row.relation === '2'") 老师
                  font(v-if="scope.row.relation === '3'") 朋友
                  font(v-if="scope.row.relation === '4'") 其他
    //-人员不符合情况弹窗
    el-dialog(title="添加人员信息不符合：" :visible.sync='addpersonError' :append-to-body='true' :modal-append-to-body='false')
        div(v-for="(e,i) in addpersonErrorInfo.split('。')" :key="i") {{e}}
        span.dialog-footer(slot="footer")
            el-button(@click="addpersonError=false") 取 消
    span.dialog-footer(slot="footer")
        el-button(@click="addSave" type="primary") 确 定
        el-button(@click="addVisible=false") 取 消
</template>
<script>
import commentData from '../common.js'
export default {
  props: ['id'],
  data () {
    return {
      addVisible: false,
      radio: '',
      memberName: '',
      trainId: '', //当前条数据id
      courseId: [],
      isPlacement: 1, //1新增 2插班
      addpersonError: false,
      addpersonErrorInfo: '',
      mbIds: '',
      childrenInfo: {
        name: '',
        sex: '',
        age: '',
        level: '',
        height: '',
        relation: '',
        birthday: '',
        chid: ''
      },
      tabloading: false,
      loading: null,
      ageOptions: ['5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15'],
      genderOptions: [
        { label: '男', value: 0 },
        { label: '女', value: 1 }
      ],
      relationOptions: [
        { label: '家长', value: '1' },
        { label: '老师', value: '2' },
        { label: '朋友', value: '3' },
        { label: '其他', value: '4' }
      ],
      levelOptions: commentData.pxLevel,
      memberData: [],
      checkedMemberlist: null,
      childrenData: [],
      zhongjian: [],
      childrenCheckedList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      InfoRules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { min: 2, max: 8, message: '长度在 2 到 8 个字符', trigger: 'blur' }
        ],
        height: [
          { required: true, message: '请输入身高', trigger: 'blur' },
          { type: 'number', message: '身高必须为数字值，单位cm' }

        ],
        sex: [
          { required: true, message: '请选择性别', trigger: 'blur' }
        ],
        age: [
          { required: true, message: '请选择年龄', trigger: 'blur' }
        ],
        level: [
          { required: true, message: '请选择等级', trigger: 'blur' }
        ],
        relation: [
          { required: true, message: '请选择关系', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init (id, val, mbIds) {
      this.trainId = id
      this.isPlacement = 1
      if (val) {
        this.isPlacement = 2 //插班
        this.courseId = val
      }
      this.mbIds = mbIds
      console.log(this.mbIds, '过滤ids===')
      this.addVisible = true
      this.getMemberList()
    },
    sizeChangeHandle (val) {
      this.pageIndex = 1
      this.pageSize = val
      this.getMemberList()
    },
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getMemberList()
    },
    childrenChecked (val) {
      this.childrenCheckedList = val
    },
    //选中某一条会员信息
    checkMember (val) {
      //赋值给radio
      this.radio = this.memberData.indexOf(val) + 1
      this.checkedMemberlist = val
    },
    addChildren () {
      this.$refs['childrenInfos'].validate((valid) => {
        if (valid) {
          this.childrenInfo.chid = new Date().getTime()
          let item = Object.assign({}, this.childrenInfo)
          this.childrenData.push(item)
          this.$refs.childrenInfos.resetFields()
          this.$forceUpdate()
        }
      })
    },
    //删除
    delChildren () {
      console.log(this.childrenCheckedList)
      if (this.childrenCheckedList.length < 1) return this.$message.error('请至少勾选一位青少年！')
      let arr = []
      this.childrenCheckedList.forEach(e => {
        arr.push(e.chid)
      })
      let arrs = this.childrenData
      this.childrenData = arrs.filter(e => arr.indexOf(e.chid) == -1)
    },
    addSave () {
      this.addEnroll()
    },

    getMemberList () {
      this.tabloading = true
      this.$http({
        url: this.$http.adornUrl(`/mbMember/getMemberList`),
        method: 'post',
        params: this.$http.adornParams({
          'page': this.pageIndex,
          'rows': this.pageSize,
          'name': this.memberName,
          'status': 1, //只查询已实名认证的会员
          'ids': this.mbIds
        })
      }).then(data => {
         this.tabloading = false
        if (data && data.code === 0) {
          this.memberData = data.list.rows
          this.totalPage = data.list.total
        } else {
          this.memberData = []
          this.totalPage = 0
        }
      })
    },
    openFullScreen () {
      this.loading = this.$loading({
          lock: true,
          text: '请稍后...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
      })
    },
     //添加人员入库
    addEnroll () {
      console.log('this.checkedMemberlist', this.checkedMemberlist)
      if (!this.checkedMemberlist) {
        this.$message.error('请选择一个会员！')
      } else {
        this.openFullScreen()
        this.childrenData.forEach(e => {
          e.birthday = new Date(e.birthday).getTime()
        })
          //先校验
          this.$http({
              url: this.$http.adornUrl(`/pxTrain/checkTrainMember`),
              method: 'post',
              data: {
                id: this.trainId,
                isPlacement: this.isPlacement, //1=新增，2=插班
                trainPersonList: [{ memberId: this.checkedMemberlist.id }],
                trainInsteadList: this.childrenData,
                courseId: this.courseId.join()
              }
          }).then(data => {
                if (data && data.code === 0) {
                    if (data.state) {
                      this.$http({
                          url: this.$http.adornUrl(`/pxTrain/addPersonSave`),
                          method: 'post',
                          data: {
                            id: this.trainId,
                            isPlacement: this.isPlacement, //1=新增，2=插班
                            trainPersonList: [{ memberId: this.checkedMemberlist.id }],
                            trainInsteadList: this.childrenData,
                            courseId: this.courseId.join()
                          }
                      }).then(data => {
                          if (data && data.code === 0) {
                              this.$message.success('添加成功!')
                              this.addVisible = false
                              this.$emit('handelSuccess')
                          } else {
                              this.$message.success('添加失败!')
                          }
                          this.loading.close()
                      })
                    } else {
                        this.loading.close()
                        this.addpersonError = true
                        this.addpersonErrorInfo = data.info
                    }
                }
          })
        }
    },
    dailogclose () {
      this.childrenData = []
      this.$refs.memTab.setCurrentRow()
      this.$nextTick(() => {
        this.$refs.childrenInfos.resetFields()
      })
    }

  }
}
</script>
<style>

</style>
